import { Navigate, Route, Routes } from "react-router-dom";
import "./App.css";
import "./Assests/Css/style.css";
import Home from "./Pages/Home";
import WebRoute from "./Routes/WebRoute";

import "./bootstrap.css";
import LanguageModal from "./Components/Common/Model/LanguageModal";
import Checkout from "./Pages/Checkout";
import AboutUs from "./Pages/CMS/AboutUs";
import Cancellaton from "./Pages/CMS/Cancellaton";
import ContactUs from "./Pages/CMS/ContactUs";
import HelpAndFaq from "./Pages/CMS/HelpAndFaq";
import JobOpening from "./Pages/CMS/JobOpening";
import PrivacyPolicy from "./Pages/CMS/PrivacyPolicy";
import SiteMap from "./Pages/CMS/SiteMap";
import TermAndServices from "./Pages/CMS/TermAndServices";
import BlogListing from "./Pages/CMS/BlogListing";
import BlogDetail from "./Pages/CMS/BlogDetail";
import Unsubscribe from "./Pages/CMS/Unsubscribe";
import Confirm from "./Pages/Confirm";
import ExperienceListing from "./Pages/ExperienceListing";
import Failure from "./Pages/Failure";

import ExperienceDetail from "./Pages/Host/ExperienceDetail";
import HostAddProfiles from "./Pages/Host/HostAddProfiles";
import HostCategory from "./Pages/Host/HostCategory";
import HostChooseExperience from "./Pages/Host/HostChooseExperience";
import Calender from "./Pages/Host/HostDashboard/Calender";
import Dashboard from "./Pages/Host/HostDashboard/Dashboard";
import Listing from "./Pages/Host/HostDashboard/Listing";
import Message from "./Pages/Host/HostDashboard/Message";
// import HostExperience from "./Pages/Host/HostExperience";

import HostSubcategory from "./Pages/Host/HostSubcategory";
import HostWhereShouldGuests from "./Pages/Host/HostWhereShouldGuests";

import ThankYou from "./Pages/ThankYou";
import AddOnlineProfiles from "./Pages/Users/AddOnlineProfiles";
import MyProfile from "./Pages/Users/MyProfile";
import UserNotification from "./Pages/Users/UserNotification";
import UserProfile from "./Pages/Users/UserProfile";

import axios from "axios";
import { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import Broken from "./Components/Common/Broken";
import CookieBanner from "./Components/Common/CookieBanner";
import BookingDetailRedirect from "./Components/Utility/BookingDetailRedirect";
import ExperienceCalender from "./Pages/Host/HostDashboard/ExperienceCalender";
import HostCurrency from "./Pages/Host/HostDashboard/HostAccountSetting/HostCurrency";
import HostNotification from "./Pages/Host/HostDashboard/HostAccountSetting/HostNotification";
import HostPayment from "./Pages/Host/HostDashboard/HostAccountSetting/HostPayment";
import HostPaymentReview from "./Pages/Host/HostDashboard/HostAccountSetting/HostPaymentReview";
import HostSetting from "./Pages/Host/HostDashboard/HostAccountSetting/HostSetting";
import HostTaxes from "./Pages/Host/HostDashboard/HostAccountSetting/HostTaxes";
import HostExperienceDetail from "./Pages/Host/HostDashboard/HostExperienceDetail";
import ReservationListing from "./Pages/Host/HostDashboard/ReservationListing";
import Review from "./Pages/Review";
import UserExperienceDetail from "./Pages/Users/UserExperienceDetail";
import UserExperiences from "./Pages/Users/UserExperiences";
import UserMessage from "./Pages/Users/UserMessage";
import UserSetting from "./Pages/Users/UserSetting";
import Wishlist from "./Pages/Users/Wishlist";
import "./responsee.css";
import HostRoute from "./Routes/HostRoute";
import HostSidebarLayout from "./Routes/HostSidebarLayout";
import UserRoute from "./Routes/UserRoute";

function App() {
  const [user, setUser] = useState(null);

  const [userLocation, setUserLocation] = useState(null);

  // Fetch user location from ipinfo.io
  useEffect(() => {
    const storedUser = localStorage.getItem("user");

    // ❗ Only call this API when NO USER is logged in
    if (storedUser) {
      return;
    }
    else{
    const fetchUserLocationAndCurrency = async () => {
      try {
        // 1️ Get user location via IP
        const ipRes = await axios.get(`${process.env.REACT_APP_API_IP}`);

        setUserLocation(ipRes.data);

        const countryCode = ipRes?.data?.country_code;
        if (!countryCode)
          return console.warn("⚠️ No country code found in IP info");

        // 2 Call currency API with country ISO code
        const currencyRes = await axios.get(
          `${process.env.REACT_APP_API_BASE}/getCurrencyByCountryIsoCode?iso_code=${countryCode}`
        );

        // 3 Extract useful data
        const currencyData = currencyRes?.data?.data;
        if (currencyData) {
          const formattedCurrency = {
            id: currencyData.id,
            exchanged_sgd_rate: currencyData.exchanged_sgd_rate,
            country_name: currencyData.country_name,
            currency: currencyData.currency,
            symbol: currencyData.symbol,
          };

          // 5️⃣ Save clean formatted data in localStorage
          localStorage.setItem(
            "selectedCurrency",
            JSON.stringify(formattedCurrency)
          );
        } else {
          // ⚠️ Fallback — Australia

          const defaultCurrency = {
            id: 6,
            exchanged_sgd_rate: "0.85",
            country_name: "Australia",
            currency: "AUD",
            symbol: "$",
          };
          localStorage.setItem(
            "selectedCurrency",
            JSON.stringify(defaultCurrency)
          );
        }
      } catch (error) {
        console.error("❌ Error fetching location or currency:", error);
      }
    };
  

    fetchUserLocationAndCurrency();
  }
  }, []);

  // Session check
  useEffect(() => {
    const expiry = localStorage.getItem("expiry");
    if (expiry && Date.now() > Number(expiry)) {
      // ✅ Session expired → remove everything
      localStorage.removeItem("user");
      localStorage.removeItem("authToken");
      localStorage.removeItem("expiry");
      localStorage.removeItem("hostData");
      localStorage.removeItem("userWishlist");
      localStorage.removeItem("selectedCurrency");
      localStorage.removeItem("pendingHid");
      localStorage.removeItem("pendingEid");

      toast.error("Your session has expired. Please log in again.");
    }
  }, []);

  return (
    <>
      <LanguageModal />
      <Toaster position="top-center" reverseOrder={false} />

      <Routes>
        <Route element={<WebRoute />}>
          <Route path="" element={<Home />} />
          <Route path="/experience/:slug" element={<ExperienceDetail />} />
          <Route path="experiences" element={<ExperienceListing />} />
          <Route path="/checkout/:id" element={<Checkout />} />
          <Route path="/confirm/:id" element={<Confirm />} />
          <Route path="thankyou" element={<ThankYou />} />
          <Route path="failure" element={<Failure />} />
          <Route
            path="booking-detail/:booking_id"
            element={<BookingDetailRedirect />}
          />

          <Route
            path="host-where-should-guests"
            element={<HostWhereShouldGuests />}
          />

          <Route path="host-add-profiles" element={<HostAddProfiles />} />

          {/* CMS Pages Route */}
          <Route path="help-and-faq" element={<HelpAndFaq />} />
          <Route path="about" element={<AboutUs />} />
          <Route path="contactus" element={<ContactUs />} />
          <Route path="job-opening" element={<JobOpening />} />
          <Route path="site-map" element={<SiteMap />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="term-service" element={<TermAndServices />} />
          <Route path="cancellation" element={<Cancellaton />} />
          <Route path="/review" element={<Review />} />
          <Route path="blogs" element={<BlogListing />} />
          <Route path="blogs/:slug" element={<BlogDetail />} />
          <Route path="unsubscribe/:token" element={<Unsubscribe />} />

          {/* CMS Pages Route end */}

          <Route path="add-online-profiles" element={<AddOnlineProfiles />} />
           <Route path="/404" element={<Broken />} />
        </Route>

        {/* User Routes */}
        <Route element={<UserRoute />}>
          <Route path="profile" element={<UserProfile />} />
          <Route path="myprofile" element={<MyProfile />} />
          <Route path="user-experience" element={<UserExperiences />} />
          <Route
            path="/user-experience-detail/:booking_id"
            element={<UserExperienceDetail />}
          />
          <Route path="chat" element={<UserMessage />} />
          <Route path="user-wishlist" element={<Wishlist />} />
          <Route path="notification" element={<UserNotification />} />
          <Route path="user-setting" element={<UserSetting />} />
        </Route>

        {/* User Routes end */}

        {/* Host Routes */}
        <Route element={<HostRoute />}>
          <Route path="host-category" element={<HostCategory />} />
          <Route path="host-subcategory" element={<HostSubcategory />} />
          <Route
            path="host-choose-experience"
            element={<HostChooseExperience />}
          />
          <Route path="reservation" element={<ReservationListing />} />
          <Route path="dashboard" element={<Dashboard />} />
          {/* <Route path="host-experience-detail" element={<HostExperienceDetail />} /> */}
          <Route
            path="/host-experience-detail/:booking_id"
            element={<HostExperienceDetail />}
          />
          <Route path="listing" element={<Listing />} />
          <Route path="calender" element={<ExperienceCalender />} />
          <Route path="experienceCalender" element={<Calender />} />
          <Route path="message" element={<Message />} />

          <Route element={<HostSidebarLayout />}>
            <Route path="account-setting" element={<HostSetting />} />
            <Route path="account-currency" element={<HostCurrency />} />
            <Route path="account-payment" element={<HostPayment />} />
            <Route path="account-tax" element={<HostTaxes />} />
            <Route path="account-notification" element={<HostNotification />} />
            <Route path="payment" element={<HostPaymentReview />} />
          </Route>
        </Route>
        {/* Host Routes end */}

        {/* 404 Route */}
       

        {/* Catch-all redirect */}
        <Route path="*" element={<Navigate to="/404" replace />} />
      </Routes>
      <CookieBanner />
    </>
  );
}

export default App;
